import { cssInterop } from 'nativewind';
import { Pressable, Text, View } from 'react-native';
import Animated from 'react-native-reanimated';

/**
 * Componentes animados registrados no NativeWind.
 * `createAnimatedComponent` gera componentes fora do registro padrão do
 * NativeWind — sem o `cssInterop`, `className` é ignorado no nativo.
 * Sempre importe estes em vez de criar novos animated components.
 */
export const AnimatedView = Animated.createAnimatedComponent(View);
export const AnimatedPressable = Animated.createAnimatedComponent(Pressable);
export const AnimatedText = Animated.createAnimatedComponent(Text);

cssInterop(AnimatedView, { className: 'style' });
cssInterop(AnimatedPressable, { className: 'style' });
cssInterop(AnimatedText, { className: 'style' });
